module.exports = __webpack_public_path__ + "img/machine_shop_01_1k.2fa36348.jpg";